
import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, Card, CardBody, ModalFooter} from 'reactstrap';

class SelectionView extends Component 
{
    render()
    {
        let components = [];
        this.props.selections.forEach (selection =>
        {
            let onClick = ()=>{};
            let background = '#DCDCDC';
            let foreground = "#484848";

            if (selection.isDisabled)
            {
                background = '#E8E8E8';
                foreground = '#989898';
            }
            else
            {
                if (!selection.isSelected)
                {
                    onClick = ()=>
                    {
                        this.props.onSelection(selection);
                        this.props.onClose();
                    }
                }
                else
                {
                    background = 'var(--colors-primary)';
                    foreground = '#F0F0F0';
                }
            }

            components.push(this.renderOptionButton(onClick, background, foreground, selection.caption));
        })

        return(<Modal isOpen={true} centered animation={false} fade={false} toggle={()=>{this.props.onClose()}} style={{minWidth:'20vw'}}>
                    <ModalHeader cssModule={{ 'modal-title': 'w-100' }} style={{background:'var(--background-color)', paddingBottom:'5px'}}>
                        <div className="caption primary-color d-flex justify-content-center">
                            {this.props.caption}
                        </div>
                    </ModalHeader>
                    <ModalBody style={{background:'var(--background-color)', paddingLeft:'10px', paddingRight:'10px'}}>
                        <div style={{ overflowX: "hidden", overflowY: "auto", maxHeight: '60vh' }}>{components}</div>
                    </ModalBody>
                </Modal>);
    }

    renderOptionButton(onClick, background, foreground, caption)
    {
        return <div onClick={onClick}>
                    <Card style={{marginTop:'0px', marginBottom:'5px', background:background, color:foreground}}>
                        <CardBody><div style={{marginTop:'3px', textAlign:'center'}}>{caption}</div></CardBody>
                    </Card>
                </div>
    }

}

export default SelectionView;